
import { FC, PropsWithChildren } from 'react';

import { useValidateSpeciesRoute } from '../../../hooks/validation/useValidateSpeciesRoute';

/**
 * -- Base Provider --
 * 
 * Purpose of this provider is to run any necessary state management 
 * at the base level of the react router dom tree for the species content.
 * 
 * I made this with the intention of updating the user when the species 
 * changes, by listenting to the react router dom path name.
 */
const BaseProvider: FC<PropsWithChildren> = ({
    children
}) => {
    // These hooks are required for components higher up
    // in the render tree.
    useValidateSpeciesRoute();

    return (
        children
    )
}

export default BaseProvider